module.exports = __webpack_public_path__ + "static/monsterinlove-6ca16c1b21abbc67e8ae88df6213cba1.jpg";